module.exports = __webpack_public_path__ + "static/media/agenda.e101302f.png";